import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { Text1, Text4 } from '../../../styles';
import { QueryForm } from '../Forms/QueryForm';


const TransferRequestQueryModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                Raise a Query
            </Text1>
        )
    };

    return (
        <EaseModal
            width={400}
            title={false}
            visible={props.visible}
            onCancel={() => props.toggleTransferQueryModal()}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <QueryForm
                onSubmit={props.onSubmit}
                isSaving={props.isSaving}
                transferRequest={props.transferRequest}
            />
        </EaseModal>
    )
};

export { TransferRequestQueryModal };